import Api from '@/shared/services/Api'


export default 
{

	get() {
		return Api().get('customer-get')
	},

	delete(id) {
		return Api().get('customer-delete?id='+id)
	}

}